<template>
  <div :style="$cmsStyles('c_a38e75d7d003')" class="media-container">
    <tools-bar ref="toolsBar"></tools-bar>
    <div class="media-content">
      <div class="service-wrapper">
        <div v-show="$cms('c_a38e75d7d003', 'f_0001', true)" class="banner-wrapper"></div>
        <div class="common-content-wrapper content-wrapper">
          <div v-show="$cms('c_a38e75d7d003', 'f_0002', true)" class="box-1">
            <div class="box-header">
              <h2 class="box-header-title">{{ $cms('c_a38e75d7d003', 'f_0003', "品牌介绍") }}</h2>
              <div class="box-header-desc">{{ $cms('c_a38e75d7d003', 'f_0004', "Brand  Introduction") }}</div>
            </div>
            <div class="box-content">
              <div class="desc">{{ $cms('c_a38e75d7d003', 'f_0005', "2024年，百谜BAIMI因爱而生，以专业之心打造兼具功效与体验的美妆个护产品。针对不同头皮需求，推出控油防断、强韧、去屑蓬松等细分洗护系列，让每个人都能找到专属护发方案。") }}<br /><br />{{ $cms('c_a38e75d7d003', 'f_0006', "我们萃取天然植物精华，用温和配方呵护头皮；匠心调配大牌香氛，让洗护成为一场感官盛宴。产品一经推出便荣登直播热销与回购榜；未来，百谜将继续以品质为笔，书写更多关于美的温暖故事！") }}</div>
            </div>
          </div>

          <div v-show="$cms('c_a38e75d7d003', 'f_0007', true)" class="box-7">
            <div class="box-header">
              <h2 class="box-header-title">{{ $cms('c_a38e75d7d003', 'f_0008', "产品介绍") }}</h2>
              <div class="box-header-en-title">{{ $cms('c_a38e75d7d003', 'f_0009', "Product Introduction") }}</div>
              <div class="box-header-desc">{{ $cms('c_a38e75d7d003', 'f_0010', "匠心调配大牌香氛") }}</div>
            </div>
            <div class="box-content">
              <div class="band-btns">
                <div class="btn" v-for="btn in brandBtns" :key="btn">{{ btn }}</div>
              </div>
              <div class="band-group-list">
                <div class="group-item" v-for="item in brandGroupList" :key="item.type">
                  <div class="group-title">{{ item.type }}</div>
                  <div class="group-item-list">
                    <div class="item" v-for="listItem in item.list" :key="listItem.name">
                      <div class="item-img">
                        <img :src="listItem.img" loading="lazy" alt="">
                      </div>
                      <div class="item-info">
                        <div class="item-name">{{ listItem.name }}</div>
                        <div class="item-desc">{{ listItem.desc }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <BrandCooperationBox />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ToolsBar from '@/components/ToolsBar.vue';
import BrandCooperationBox from '@/components/brand/BrandCooperationBox.vue';

export default {
  components: {
    ToolsBar,
    BrandCooperationBox,
  },
  head() { return this.$cmsHead('c_a38e75d7d003', {
    title: '百谜-为你的美丽加分|美妆个护|洗护用品|香氛洗发|魔筷科技',
    meta: [
      {
        name: 'Keywords',
        content:
          '百谜,美妆个护,洗护用品,香氛洗发,控油防断,强韧洗发,去屑蓬松,头皮护理,天然植物精华,大牌香氛,快手,抖音,视频号,小红书,魔筷科技',
      },
      {
        name: 'Description',
        content:
          '百谜BAIMI因爱而生，以专业之心打造兼具功效与体验的美妆个护产品。针对不同头皮需求，推出控油防断、强韧、去屑蓬松等细分洗护系列，萃取天然植物精华，匠心调配大牌香氛，为你的美丽加分。',
      },
    ],
  }); },
  data() {
    return {
      brandBtns: this.$cms('c_a38e75d7d003', 'f_0011', ["全部产品","衣物清洁护理","家庭清洁护理"]),
      brandGroupList: this.$cms('c_a38e75d7d003', 'f_0012', [{"type":"衣物清洁护理","list":[{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250905140759620000144.17570524792359647.png","name":"深层洁净洗衣液"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250905140759630000679.17570524792397128.png","name":"香氛洁净洗衣液"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250905140759630000837.17570524792408144.png","name":"除菌洁净洗衣液"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250905140759620000509.17570524792411957.png","name":"内衣洗衣液"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250905140759630000623.17570524792399001.png","name":"馨香洁净洗衣液"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250905140759630000696.17570524792481259.png","name":"酵素香氛洗衣原浆"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250905140759630000877.17570524792425937.png","name":"小白鞋清洁剂"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250905140759630000956.17570524792418864.png","name":"亮彩氧泡净"}]},{"type":"家庭清洁护理","list":[{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250905140759630000684.17570524792385201.png","name":"强力去油洗洁精"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250905140759630000444.17570524792465819.png","name":"地板清洁剂"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250905140759620000365.17570524792462423.png","name":"重油污净"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250905140759620000830.17570524792451657.png","name":"艾草精油地板清洁剂"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250905140759620000110.17570524792371252.png","name":"酵素果蔬餐具净"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250905140759630000695.17570524792449914.png","name":"松香净护洁厕液"}]}]),
    }
  },
  mounted() {
    // this.initFullpage()
    this.$refs.toolsBar.show()
  },
  methods: {
   
  },
}
</script>

<style lang="less" scoped>
@import "../../style/common.less";

.media-content {
  padding-top: 90px;
}

.service-wrapper {
  .banner-wrapper {
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    .pxToVw(height, 680);
    background-image: var(--cms-c_a38e75d7d003-f_0013, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250908162057160000289.17573196568422574.jpg?x-oss-process=image/quality,Q_90"));
    background-size: cover;
    background-repeat: no-repeat;
    h1.title {
      .pxToVw(margin-bottom, 13);
      line-height: 1.4;
      .pxToVw(font-size, 60);
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #fff;
    }
    .desc {
      .pxToVw(line-height, 33);
      .pxToVw(font-size, 24);
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
    }
    .actions {
      display: flex;
      align-items: center;
      .pxToVw(margin-top, 77);
    }
  }
  .content-wrapper {
    .box-1 {
      background: #FFF;
      .box-content {
        margin: 0 auto;
        .pxToVw(margin-top, 60);
        .pxToVw(width, 1440);
        .pxToVw(height, 627);
        background-image: var(--cms-c_a38e75d7d003-f_0014, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250908171416120000619.17573228558058738.png"));
        background-size: cover;
        background-repeat: no-repeat;
        box-sizing: border-box;
        position: relative;
        .pxToVw(padding-top, 170);
        .pxToVw(padding-left, 80);
        .desc {
          .pxToVw(width, 600);
          font-weight: 400;
          .pxToVw(font-size, 24);
          .pxToVw(line-height, 40);
          color: #666666;
        }
      }
    }

    .box-3 {
      background: #FFF;

    }

    .box-7 {
      background: #FFF;
      .pxToVw(padding-bottom, 80);
      .band-btns {
        display: flex;
        justify-content: center;
        .pxToVw(gap, 40);
        .pxToVw(padding-top, 60);
        .pxToVw(padding-bottom, 60);
        .btn {
          .pxToVw(width, 210);
          .pxToVw(height, 48);
          .pxToVw(border-radius, 30);
          .pxToVw(font-size, 18);
          .pxToVw(line-height, 25);
          box-sizing: border-box;
          font-weight: 400;
          color: #333333;
          border: 1px solid #999999;
          display: flex;
          align-items: center;
          justify-content: center;

          &:first-child {
            background: linear-gradient( 90deg, #FF6600 0%, #FC4440 100%);
            border: none;
            color: #fff;
          }
        }
      }

      .band-group-list {
        display: flex;
        flex-wrap: wrap;
        .pxToVw(padding-top, 80);
        .pxToVw(width, 1440);
        margin: 0 auto;
        .pxToVw(gap, 30);
        .group-title {
          font-weight: 600;
          .pxToVw(font-size, 30);
          .pxToVw(line-height, 42);
          .pxToVw(margin-bottom, 30);
          color: #333333;
        }
        .group-item {
          width: 100%;
        }
        .group-item-list {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          .item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .pxToVw(width, 360);
            .pxToVw(height, 293);
            background: #fbfbfb;
            box-sizing: border-box;
            .item-img {
              .pxToVw(width, 180);
              .pxToVw(height, 180);
              border-radius: 50%;
              background: #FFFFFF;
              // border: 1px solid #CCCCCC;
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                display: block;
                border-radius: 50%;
                .pxToVw(width, 180);
                .pxToVw(height, 180);
              }
            }
            .item-name {
              .pxToVw(margin-top, 20);
              font-weight: 600;
              .pxToVw(font-size, 24);
              .pxToVw(line-height, 33);
              color: #333333;
            }
          }
        }
      }
    }
  }
}
</style>
